(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card-sizes"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const button = event.target.closest('.product-card-sizes__button');
    if (!button) return;
    const form = button.closest('form');
    const variantInput = form?.querySelector('input[name="id"]');
    if (variantInput) variantInput.value = button.dataset.variantId;
  });
  } catch(e) { console.error(e); }
})();

})();
